<template>
    <div id="app-container">
        <div id="extension-payment-placeholder-creditControlPaymentGroup" class=" box-payment-option">
            <div class="">
                <div>
                    <div style="background-color: rgb(255, 230, 230); padding: 20px; margin: 0px 0px 20px;" v-bind:class="availableCredit < total ? 'visible' : 'hide'">
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <span style="margin-right: 10px;"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.5 10.1L10.1 11.5L8 9.4L5.9 11.5L4.5 10.1L6.6 8L4.5 5.9L5.9 4.5L8 6.6L10.1 4.5L11.5 5.9L9.4 8L11.5 10.1Z" fill="#FF4C4C"></path></svg>
                            </span>
                            <p style="margin: 0px; line-height: normal;">Você não tem crédito disponível suficiente para fazer essa compra agora.<a href="https://www.lavillecasa.com.br/credito/comprar"> Deseja completar o saldo? Acesse aqui</a>
                            </p>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px;">
                        <p style="margin: 0px;"><strong>Crédito disponível</strong></p>
                        <p style="font-size: 16px;">{{currency(availableCredit)}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped src="@/assets/css/checkout-paymentcreditcard.module.css"></style>
<script>
    import customerCreditApi from "@/services/api/customerCreditAPI.js";
    import formatter from "@/mixins/formatter.js";
    export default {
        name: 'payment-customercredit',
        props: ['total', 'enablePaymentButton'],
        mixins: [formatter],
        data: () => ({
            paymentCustomerCredit: {
                id : ''
            },
            document: '',
            availableCredit: 0
        }),
        mounted() {

        },
        computed: {
        },
        methods: {
            getData() {
                this.enablePaymentButton(false);
                if (typeof document.session === 'undefined') {
                    location.href = 'https://www.lavillecasa.com.br/loginapp';
                    return;
                }
                var self = this;
                customerCreditApi.getAccount(document.session)
                    .then(data => {
                        if (data) {
                            console.log(data);
                            self.availableCredit = data.data.availableCredit;
                            self.paymentCustomerCredit.id = data.data.id;
                            if (self.availableCredit >= self.total) this.enablePaymentButton(true);
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => {
                    });
            },
            getDataStore(email) {
                this.enablePaymentButton(false);
                if (email == null || email.length == 0) {
                    return;
                }
                var self = this;
                customerCreditApi.getAccountByEmail(email)
                    .then(data => {
                        if (data) {
                            console.log(data);
                            self.availableCredit = data.data.availableCredit;
                            self.paymentCustomerCredit.id = data.data.id;
                            if (self.availableCredit >= self.total) this.enablePaymentButton(true);
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => {
                    });
            }
        }
    }
</script>

